var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('medium-editor',{staticClass:"form-input-text medium-editor",class:{
      'form-field-error': _vm.vee ? _vm.vee.classes.failed : false,
      disabled: _vm.options.disableEditing,
    },attrs:{"id":_vm.id,"text":_vm.value,"options":_vm.options,"custom-tag":"div"},on:{"edit":_vm.processEditOperation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }